
import React, { useEffect, useState } from 'react'
// import { postCambiodeEstadooUSer, postHGquirofano, postSelectCambiarEstadoPaciente, postTodosLosEstadosUser } from '../services/PaginaRuta';
import ModalCirugia from './ModalCirugia';
//import ModalAgregarPaquetesQuirurgicosP from './cirugia/paquetesQuirurgicos/ModalAgregarPaquetesQuirurgicosP'
import ModalAgregarPaquetesQuirurgicos from './cirugia/modalProcedimiento/ModalAgregarPaquetesQuirurgicos'
import ModalConfirmarElActoQuirurgico from './ModalConfirmarElActoQuirurgico';
import ModalConsentimientoInformado from '../pages/ModalConsentimientoInformado';
import CambioDeEstadoReservado from './cirugia/cambioDeEstado/CambioDeEstadoReservado';
import CambioDeEstadoIngresoASala from './cirugia/cambioDeEstado/CambioDeEstadoIngresoASala';
import CambioDeEstadoPreparado from './cirugia/cambioDeEstado/CambioDeEstadoPreparado';
import CambioDeEstadoCirugia from './cirugia/cambioDeEstado/CambioDeEstadoCirugia';
import CambioDeEstadoRecuperacion from './cirugia/cambioDeEstado/CambioDeEstadoRecuperacion';
import CambioDeEstadoSalida from './cirugia/cambioDeEstado/CambioDeEstadoSalida';
import ModalValidarDiagnosticoAntesDeConfirmarCirugia from './ModalValidarDiagnosticoAntesDeConfirmarCirugia';
import { calcularEdad } from '../hooks/UseDate';
import ModalValidarQuirofano from './cirugia/cambioDeEstado/ModalValidarQuirofano';
import CambioDeEstadoCancelar from './cirugia/cambioDeEstado/CambioDeEstadoCancelar';
import ModalValidarButtonModificarProgramacionCirugia from './ModalValidarButtonModificarProgramacionCirugia';
import CambioDeEstadoRealizada from './cirugia/cambioDeEstado/CambioDeEstadoRealizada';
import NovedadesAdministrativas from './cirugia/novedadesAdministrativas/NovedadesAdministrativas';


const TablaProgramacionCirugia = (props) => {
    //const [estadoPaciente, setEstadoPaciente]=useState('')
    const [modalOn, setModalOn] = useState(false);
    const [choice, setChoice] = useState(false)
    const [modalOnAgregarPaquetesQuirurgicos,setmodalOnAgregarPaquetesQuirurgicos]=useState(false)
    const [modalOnConfirmar, setmodalOnConfirmar]=useState(false)
    const [modalOnConsentimientoInformado, setmodalOnConsentimientoInformado]=useState(false)
    const [modalOnCambioEstadoReservado, setmodalOnCambioEstadoReservado]=useState(false)
    const [modalOnCambioEstadoIngresoSala, setmodalOnCambioEstadoIngresoSala]=useState(false)
    const [modalOnCambioEstadoPreparado, setmodalOnCambioEstadoPreparado]=useState(false)
    const [modalOnCambioEstadoCirugia,setmodalOnCambioEstadoCirugia]=useState(false)
    const [modalOnCambioEstadoRecuperacion, setmodalOnCambioEstadoRecuperacion]=useState(false)
    const [modalOnCambioEstadoSalida, setmodalOnCambioEstadoSalida]=useState(false)
    const [modalOnCambioEstadoRealizada, setmodalOnCambioEstadoRealizada]=useState(false)
    const [modalOnValidarDiagnostico, setmodalOnValidarDiagnostico]=useState(false)
    const [actualizarTable, setactualizarTable]=useState([])
    // const [dataQuirofanos, setdataQuirofanos]=useState([])
    const [validarQuirofano, setvalidarQuirofano]=useState(false)
    const [modalOnCambioEstadoCancelado, setmodalOnCambioEstadoCancelado]= useState(false)
    //const [modalOnCambioEstadoCancelar, setmodalOnCambioEstadoCancelar]= useState(true)
    const [modalOnModificarButton, setmodalOnModificarButton]=useState(false)
    const [novedadesAdministra, setnovedadesAdministra]=useState(false)

    //diseable

    
    
    const [diseableCambioEstado, setdiseableCambioEstado]=useState({
      estadoPaciente:'6',
      disabledPendiente:false,
      disabledReservado:false,
      disabledConfirmado:false,
      disabledIngresoSala:false,
      disabledPreparado:false,
      disabledCirugia:false,
      disabledRecuperacion:false,
      disabledSalida:false,
      disabledCancelar:false,
      disabledRealizada:false,
      disabledFacturada:false,
      disabledReprogramar:false
    })
    //sconsole.log('prueba ferua de la funcioanesl')
    const passActualizarTablaProcedimiento=(data)=>{
      setactualizarTable(data)
    }

    const passChildCambioDeEstado=(data)=>{
      setdiseableCambioEstado(data)
    }

    const handleClickConsentimientoInformado=()=>{
      setmodalOnConsentimientoInformado(true)
    }

    useEffect(()=>{
      let nombreQ=''
      if(props.user.ProCons){
         nombreQ={
          ConsCod:props.user.ProCons
        }
      }

      if(props.user.ProEsta === '6'){
              setdiseableCambioEstado({
                estadoPaciente:'6',
                disabledPendiente:true,
                disabledReservado:false,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:true,
                disabledRecuperacion:true,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true,
                disabledReprogramar:true
              })
              //setmodalOnCambioEstadoCancelar(true)
      }else if(props.user.ProEsta === '3'){
        setdiseableCambioEstado({
          estadoPaciente:'3',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:true,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:true,
          disabledRealizada:true,
          disabledFacturada:true,
          disabledReprogramar:true
        })
      }
      else if(props.user.ProEsta === '5'){
        setdiseableCambioEstado({
          estadoPaciente:'5',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:true,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:true,
          disabledRealizada:true,
          disabledFacturada:true,
          disabledReprogramar:true
        })
        //setmodalOnCambioEstadoCancelar(true)
      }
      else if(props.user.ProEsta === '8'){
        setdiseableCambioEstado({
          estadoPaciente:'8',
                disabledPendiente:true,
                disabledReservado:false,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:true,
                disabledRecuperacion:true,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true,
                disabledReprogramar:true
        })
        //setmodalOnCambioEstadoCancelar(true)
      }
      else if(props.user.ultimoEstado ==='salida'){
        setdiseableCambioEstado({
          estadoPaciente:'14',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:true,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:true,
          disabledRealizada:false,
          disabledFacturada:true,
          disabledReprogramar:true
        })
        //setmodalOnCambioEstadoCancelar(true)
}
      else if(props.user.ultimoEstado ==='recuperacion'){
        setdiseableCambioEstado({
          estadoPaciente:'15',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:true,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:false,
          disabledCancelar:true,
          disabledRealizada:true,
          disabledFacturada:true,
          disabledReprogramar:true
        })
        
      }
      else if(props.user.ProEsta === '4'){
        setdiseableCambioEstado({
          estadoPaciente:'4',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:true,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:true,
          disabledRealizada:true,
          disabledFacturada:true,
          disabledReprogramar:true
        })
          //setmodalOnCambioEstadoCancelar(false)
      }
      
       else if(props.user.ultimoEstado ==='reservado' ){
            setdiseableCambioEstado({
              estadoPaciente:'1',
              disabledPendiente:true,
              disabledReservado:true,
              disabledConfirmado:false,
              disabledIngresoSala:true,
              disabledPreparado:true,
              disabledCirugia:true,
              disabledRecuperacion:true,
              disabledSalida:true,
              disabledCancelar:false,
              disabledRealizada:true,
              disabledFacturada:true,
              disabledReprogramar:true
            })
            //setmodalOnCambioEstadoCancelar(false)
      }else if(props.user.ultimoEstado ==='confirmado'){
            setdiseableCambioEstado({
              estadoPaciente:'2',
              disabledPendiente:true,
              disabledReservado:true,
              disabledConfirmado:true,
              disabledIngresoSala:false,
              disabledPreparado:true,
              disabledCirugia:true,
              disabledRecuperacion:true,
              disabledSalida:true,
              disabledCancelar:false,
              disabledRealizada:true,
              disabledFacturada:true,
              disabledReprogramar:true
            })
              //setmodalOnCambioEstadoCancelar(false)
      }else if(props.user.ultimoEstado ==='ingreso a sala'){
              setdiseableCambioEstado({
                estadoPaciente:'11',
                disabledPendiente:true,
                disabledReservado:true,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:false,
                disabledCirugia:true,
                disabledRecuperacion:true,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true,
                disabledReprogramar:true
              })
              //setmodalOnCambioEstadoCancelar(true)
      }else if(props.user.ultimoEstado ==='preparado'){
              setdiseableCambioEstado({
                estadoPaciente:'12',
                disabledPendiente:true,
                disabledReservado:true,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:false,
                disabledRecuperacion:true,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true,
                disabledReprogramar:true
              })
              //setmodalOnCambioEstadoCancelar(true)
      }else if(props.user.ultimoEstado ==='cirugia'){
              setdiseableCambioEstado({
                estadoPaciente:'13',
                disabledPendiente:true,
                disabledReservado:true,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:true,
                disabledRecuperacion:false,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true,
                disabledReprogramar:true
              })
              //setmodalOnCambioEstadoCancelar(true)
      }
      
      /////estados quemados
      else if(props.user.ProEsta === '1'){
        setdiseableCambioEstado({
          estadoPaciente:'1',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:false,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:false,
          disabledRealizada:true,
          disabledFacturada:true,
          disabledReprogramar:true
        })
        //setmodalOnCambioEstadoCancelar(false)
      }
      else if(props.user.ProEsta === '7'){
        setdiseableCambioEstado({
          estadoPaciente:'1',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:false,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:false,
          disabledRealizada:true,
          disabledFacturada:true,
          disabledReprogramar:true
        })
        //setmodalOnCambioEstadoCancelar(false)
      }else if(props.user.ProEsta === '2'){
        setdiseableCambioEstado({
          estadoPaciente:'2',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:true,
          disabledIngresoSala:false,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:false,
          disabledRealizada:true,
          disabledFacturada:true,
          disabledReprogramar:true
        })
          //setmodalOnCambioEstadoCancelar(false)
      }
      
      
      // postHGquirofano(nombreQ).then((res)=>{
      //   //console.log(res.data,'quirofanos')
      //   if(res.data[0]){
      //     setdataQuirofanos(res.data[0])
      //   }
      // })
      //console.log(props.user,'logitu')
      // let bodyreservado={
      //   Id_cirugia:props.user.ProCirCod
      // }
      // postTodosLosEstadosUser(bodyreservado).then((res)=>{
      //   let reservadoVerificar= res.data.some((item)=>item.estado_paciente=='reservado')
      //   if(!reservadoVerificar){
      //     let fecha = new Date();
      //     let mes = `${fecha.getMonth() + 1}`    
      //     if(mes.length === 1){
      //       mes = "0" + mes
      //     }
      //     let dia = `${fecha.getDate()}`
      //     if(dia.length === 1){
      //       dia = "0" + dia
      //     }
          
      //     const body = {
      //       Id_cirugia: props.user.ProCirCod,
      //       cedula_paciente: props.user.MPCedu,
      //       nombre_cirujano: props.user.MPNOMC,
      //       nombre_paciente: props.user.MPNOMC,
      //       estado_paciente: 'reservado',
      //       fecha_cambio_estado: `${fecha.getFullYear()}-${mes}-${dia}`,
      //       hora_cambio_estado: `${fecha.getHours()}:${fecha.getMinutes()}`,
      //     };
          
      //     postSelectCambiarEstadoPaciente(body);
      //   }
      // })
      //console.log(props.user.ProEsta,'ProEsta ProEsta')
      
      // let body={
      //   Id_cirugia:props.user.ProCirCod
      // }
      // if(props.user.ProEsta != '3'){
      // postTodosLosEstadosUser(body).then((res)=>{
      //   //console.log(res.data,'todo los estados del user')
        
      //   if(res.data){
      //     //console.log(res.data.length,'if entro')
      //     if(res.data.length =='0'){
      //       setdiseableCambioEstado({
      //         estadoPaciente:'6',
      //         disabledPendiente:true,
      //         disabledReservado:false,
      //         disabledConfirmado:true,
      //         disabledIngresoSala:true,
      //         disabledPreparado:true,
      //         disabledCirugia:true,
      //         disabledRecuperacion:true,
      //         disabledSalida:true
      //       })
      //       setmodalOnCambioEstadoCancelar(true)
      //     }
      //     if(res.data.length =='1' ){
      //       setdiseableCambioEstado({
      //         estadoPaciente:'1',
      //         disabledPendiente:true,
      //         disabledReservado:true,
      //         disabledConfirmado:false,
      //         disabledIngresoSala:true,
      //         disabledPreparado:true,
      //         disabledCirugia:true,
      //         disabledRecuperacion:true,
      //         disabledSalida:true
      //       })
      //       setmodalOnCambioEstadoCancelar(false)
      //     }
      //     else if(res.data.length =='2'){
      //       setdiseableCambioEstado({
      //         estadoPaciente:'2',
      //         disabledPendiente:true,
      //         disabledReservado:true,
      //         disabledConfirmado:true,
      //         disabledIngresoSala:false,
      //         disabledPreparado:true,
      //         disabledCirugia:true,
      //         disabledRecuperacion:true,
      //         disabledSalida:true
      //       })
      //       setmodalOnCambioEstadoCancelar(false)
      //     }else if(res.data.length =='3'){
      //       setdiseableCambioEstado({
      //         estadoPaciente:'11',
      //         disabledPendiente:true,
      //         disabledReservado:true,
      //         disabledConfirmado:true,
      //         disabledIngresoSala:true,
      //         disabledPreparado:false,
      //         disabledCirugia:true,
      //         disabledRecuperacion:true,
      //         disabledSalida:true
      //       })
      //       setmodalOnCambioEstadoCancelar(true)
      //     }else if(res.data.length =='4'){
      //       setdiseableCambioEstado({
      //         estadoPaciente:'12',
      //         disabledPendiente:true,
      //         disabledReservado:true,
      //         disabledConfirmado:true,
      //         disabledIngresoSala:true,
      //         disabledPreparado:true,
      //         disabledCirugia:false,
      //         disabledRecuperacion:true,
      //         disabledSalida:true
      //       })
            
      //     }else if(res.data.length =='5'){
      //       setdiseableCambioEstado({
      //         estadoPaciente:'13',
      //         disabledPendiente:true,
      //         disabledReservado:true,
      //         disabledConfirmado:true,
      //         disabledIngresoSala:true,
      //         disabledPreparado:true,
      //         disabledCirugia:true,
      //         disabledRecuperacion:false,
      //         disabledSalida:true
      //       })
      //       setmodalOnCambioEstadoCancelar(true)
      //     }else if(res.data.length =='6'){
      //       setdiseableCambioEstado({
      //         estadoPaciente:'4',
      //         disabledPendiente:true,
      //         disabledReservado:true,
      //         disabledConfirmado:true,
      //         disabledIngresoSala:true,
      //         disabledPreparado:true,
      //         disabledCirugia:true,
      //         disabledRecuperacion:true,
      //         disabledSalida:false
      //       })
            
      //     }else if(res.data.length =='7'){
      //       setdiseableCambioEstado({
      //         estadoPaciente:'14',
      //         disabledPendiente:true,
      //         disabledReservado:true,
      //         disabledConfirmado:true,
      //         disabledIngresoSala:true,
      //         disabledPreparado:true,
      //         disabledCirugia:true,
      //         disabledRecuperacion:true,
      //         disabledSalida:true
      //       })
      //       setmodalOnCambioEstadoCancelar(true)
      //     }
      //   }
        
      // })
    // }else{
    //   setdiseableCambioEstado({
    //     estadoPaciente:'3',
    //     disabledPendiente:true,
    //     disabledReservado:true,
    //     disabledConfirmado:true,
    //     disabledIngresoSala:true,
    //     disabledPreparado:true,
    //     disabledCirugia:true,
    //     disabledRecuperacion:true,
    //     disabledSalida:true
    //   })
    //   setmodalOnCambioEstadoCancelar(true)
    // }
    },[actualizarTable,props.user.ProCirCod])

    const handleOnclickPaquetesQx=()=>{
      //setmodalOnPaquetesQx(true)
      if(props.user.ProEsta == '4'){
        setmodalOnModificarButton(true)
      }else{
        setmodalOnAgregarPaquetesQuirurgicos(true)
      }
      
    }

    const modificar = ()=>{  
      if(parseInt(props.user.ProEsta) === 4){
        setmodalOnModificarButton(true)
      }else{
        setModalOn(true)
      }
        
      }

    const handleState =  (e) =>{
        e.preventDefault();

        if("1" === e.target.value){
          if(props.user.ConsDet == null || props.user.ConsDet== ''){
            setvalidarQuirofano(true)
          }else{
            setmodalOnCambioEstadoReservado(true)
          }
          
        }
        if(e.target.value == "2"){          
          if(props.user.ProDxppal=="     " || props.user.ProDxppal=='' || props.user.ProDxppal==null){            
            setmodalOnValidarDiagnostico(true)
          }else if(props.user.ProDxppal){            
            setmodalOnConfirmar(true)
          }else{
            setmodalOnValidarDiagnostico(true)
          }
          
          
        }
        if(e.target.value == "11"){
          setmodalOnCambioEstadoIngresoSala(true)
        }
        if(e.target.value == "12"){
          setmodalOnCambioEstadoPreparado(true)
        }
        if(e.target.value == "13"){
          setmodalOnCambioEstadoCirugia(true)
        }
        if(e.target.value == "15"){
          setmodalOnCambioEstadoRecuperacion(true)
        }
        if(e.target.value == "14"){
          setmodalOnCambioEstadoSalida(true)
        }
        if(e.target.value == "3"){
          setmodalOnCambioEstadoCancelado(true)
        }
        if(e.target.value == "4"){
          setmodalOnCambioEstadoRealizada(true)
        }

        
        
        
        
        ///DISEABLE
        // if ("6" === e.target.value) {
        //   setEstadoPaciente(e.target.value);
        //   setDisabledPendiente(true);
        //   setDisabledReservado(true);
        //   setDisabledConfirmado(false);
        //   setDisabledIngresoSala(true);
        //   setDisabledPreparado(true);
        //   setDisabledCirugia(true);
        //   setDisabledRecuperacion(true);
        //   setDisabledSalida(true);
        // } else if ("1" === e.target.value) {
        //   setEstadoPaciente(e.target.value);
        //   setDisabledPendiente(true);
        //   setDisabledReservado(false);
        //   setDisabledConfirmado(true);
        //   setDisabledIngresoSala(true);
        //   setDisabledPreparado(true);
        //   setDisabledCirugia(true);
        //   setDisabledRecuperacion(true);
        //   setDisabledSalida(true);
        // } else if ("2" === e.target.value){
        //   setEstadoPaciente(e.target.value);
        //   setDisabledPendiente(true);
        //   setDisabledReservado(true);
        //   setDisabledConfirmado(true);
        //   setDisabledIngresoSala(false);
        //   setDisabledPreparado(true);
        //   setDisabledCirugia(true);
        //   setDisabledRecuperacion(true);
        //   setDisabledSalida(true);
        // } else if ("11" === e.target.value) {
        //   setEstadoPaciente(e.target.value);
        //   setDisabledPendiente(true);
        //   setDisabledReservado(true);
        //   setDisabledConfirmado(true);
        //   setDisabledIngresoSala(true);
        //   setDisabledPreparado(false);
        //   setDisabledCirugia(true);
        //   setDisabledRecuperacion(true);
        //   setDisabledSalida(true);
        // } else if ("12" === e.target.value) {
        //   setEstadoPaciente(e.target.value);
        //   setDisabledPendiente(true);
        //   setDisabledReservado(true);
        //   setDisabledConfirmado(true);
        //   setDisabledIngresoSala(true);
        //   setDisabledPreparado(true);
        //   setDisabledCirugia(false);
        //   setDisabledRecuperacion(true);
        //   setDisabledSalida(true);
        // } else if ("13" === e.target.value) {
        //   setEstadoPaciente(e.target.value);
        //   setDisabledPendiente(true);
        //   setDisabledReservado(true);
        //   setDisabledConfirmado(true);
        //   setDisabledIngresoSala(true);
        //   setDisabledPreparado(true);
        //   setDisabledCirugia(true);
        //   setDisabledRecuperacion(false);
        //   setDisabledSalida(true);
        // } else if ("4" === e.target.value) {
        //   setEstadoPaciente(e.target.value);
        //   setDisabledPendiente(true);
        //   setDisabledReservado(true);
        //   setDisabledConfirmado(true);
        //   setDisabledIngresoSala(true);
        //   setDisabledPreparado(true);
        //   setDisabledCirugia(true);
        //   setDisabledRecuperacion(true);
        //   setDisabledSalida(false);
        // }else if("14" === e.target.value){
        //   setEstadoPaciente(e.target.value);
        //   setDisabledPendiente(true);
        //   setDisabledReservado(true);
        //   setDisabledConfirmado(true);
        //   setDisabledIngresoSala(true);
        //   setDisabledPreparado(true);
        //   setDisabledCirugia(true);
        //   setDisabledRecuperacion(true);
        //   setDisabledSalida(true);
        // }

        /////FIN
      //   const cambioEstadoUSer={
      //     ProCirCod: props.user.ProCirCod,
      //     ProMCDpto: "001      ",
      //     ProEmpCod: "1 ",
      //     ProEsta: "2",
      //     PUsrConf: "CUE9F3Q8  ",
      //     PROHEMCIR: "",
      //     ProFliSol: "24",
      //     ProCtvIn: "0",
      //     MPCedu: props.user.MPCedu,
      //     MPTDoc: props.user.MPTDoc
      // }
      // let bodyreservado={
      //   Id_cirugia:props.user.ProCirCod
      // }
      // postTodosLosEstadosUser(bodyreservado).then((res)=>{
      //   let reservadoVerificar= res.data.some((item)=>item.estado_paciente=='reservado')
      //   if(!reservadoVerificar){
      //     let fecha = new Date();
      //     let mes = `${fecha.getMonth() + 1}`    
      //     if(mes.length === 1){
      //       mes = "0" + mes
      //     }
      //     let dia = `${fecha.getDate()}`
      //     if(dia.length === 1){
      //       dia = "0" + dia
      //     }
          
      //     const body = {
      //       Id_cirugia: props.user.ProCirCod,
      //       cedula_paciente: props.user.MPCedu,
      //       nombre_cirujano: props.user.MPNOMC,
      //       nombre_paciente: props.user.MPNOMC,
      //       estado_paciente: 'reservado',
      //       fecha_cambio_estado: `${fecha.getFullYear()}-${mes}-${dia}`,
      //       hora_cambio_estado: `${fecha.getHours()}:${fecha.getMinutes()}`,
      //     };
          
      //     postSelectCambiarEstadoPaciente(body);
      //   }
      // })

        

        // let estadoTablero=''
        // if(e.target.value == "6"){
        //   estadoTablero='pendiente'
        //   //setEstadoPaciente('6')
        // }else if(e.target.value == "1"){
        //   estadoTablero='reservado'
        //   //setEstadoPaciente('1')
        // }else if(e.target.value == "2"){
        //   estadoTablero='confirmado'
        //   //setEstadoPaciente('2')
        // }else if(e.target.value == "11"){
        //   estadoTablero='ingreso a sala'
        //   //setEstadoPaciente('11')
        // }else if(e.target.value == "12"){
        //   estadoTablero='preparado'
        //   //setEstadoPaciente('12')
        // }else if(e.target.value == "13"){
        //   estadoTablero='cirugia'
        //   //setEstadoPaciente('13')
        // }else if(e.target.value == "4"){
        //   estadoTablero='recuperacion'
        //   //setEstadoPaciente('4')
        // }else if(e.target.value == "14"){
        //   estadoTablero='salida'
        //   //setEstadoPaciente('14')
        // }
        //console.log(estadoTablero,'estadoTablero')
       
        //TABLA DE MOVIMIENTO PARA EL TABLERO
        // let fecha = new Date();
        // let mes = `${fecha.getMonth() + 1}`    
        // if(mes.length === 1){
        //   mes = "0" + mes
        // }
        // let dia = `${fecha.getDate()}`
        // if(dia.length === 1){
        //   dia = "0" + dia
        // }
        
        // const body = {
        //   Id_cirugia: props.user.ProCirCod,
        //   cedula_paciente: props.user.MPCedu,
        //   nombre_cirujano: props.user.MPNOMC,
        //   nombre_paciente: props.user.MPNOMC,
        //   estado_paciente: estadoTablero,
        //   fecha_cambio_estado: `${fecha.getFullYear()}-${mes}-${dia}`,
        //   hora_cambio_estado: `${fecha.getHours()}:${fecha.getMinutes()}`,
        // };
        
        // postSelectCambiarEstadoPaciente(body);
        /////FIN

        ///CAMBIO DE ESTADO
        // if(e.target.value == "6" || e.target.value == "1" || e.target.value == "2" || e.target.value == "4"){
        //   const bodyUpdate={
        //     ProCirCod: props.user.ProCirCod,
        //     ProMCDpto: "001      ",
        //     ProEmpCod: "1 ",
        //     ProEsta: e.target.value,
        //     PUsrConf: "CUE9F3Q8  ",
        //     PROHEMCIR: "",
        //     ProFliSol: "24",
        //     ProCtvIn: "0",
        //     MPCedu: props.user.MPCedu,
        //     MPTDoc: props.user.MPTDoc
        //   }
        //   console.log(bodyUpdate,'camiooupfdatee')
        //   postCambiodeEstadooUSer(bodyUpdate).then((res)=>{
        //     //console.log(res.data,'cambio de estadoooooooooooo')
        // })
        // }
        ///FIN

      }

                    // <option value="pendiente">Pendiente</option>
                    // <option value="reservado">Reservado</option>
                    // <option value="confirmado">Confirmado</option>
                    // <option value="ingreso a sala">Ingreso a sala</option>
                    // <option value="preparado">Preparación</option>
                    // <option value="cirugia">Cirugía</option>
                    // <option value="recuperacion">Recuperación</option>
                    // <option value="salida">Salida</option>
      
      //novedades administrativas
      const handleOnClickNovedadesAdministrativas=()=>{
        setnovedadesAdministra(true)
      }

  return (
    
        <>
         <tbody >
        <tr className={(props.user.cantidadProcedimientos > 1)?"divide-y divide-slate-700 bg-[#a7f3d0]":"divide-y divide-slate-700 "}>
          <td></td>
          <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
            <div className="pt-2 w-32 ">
              <div className="mb-3 xl:w-96">
                <select onChange={handleState} value={diseableCambioEstado.estadoPaciente} className="form-select block w-30 px-2 py-1.5 text-base font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat
                  border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 
                  aria-label="Default select example">
                    {/* <option value="6" disabled={diseableCambioEstado.disabledPendiente}>Pendiente</option>
                    <option value="1" disabled={diseableCambioEstado.disabledReservado}>Reservado</option>
                    <option value="2" disabled={diseableCambioEstado.disabledConfirmado}>Confirmado</option>
                    <option value="11" disabled={diseableCambioEstado.disabledIngresoSala}>Ingreso a sala</option>
                    <option value="12" disabled={diseableCambioEstado.disabledPreparado}>Preparación</option>
                    <option value="13" disabled={diseableCambioEstado.disabledCirugia}>Cirugía</option>
                    <option value="15" disabled={diseableCambioEstado.disabledRecuperacion}>Recuperación</option>
                    <option value="14" disabled={diseableCambioEstado.disabledSalida}>Salida</option>
                    <option value="4" disabled={true}>Realizada</option>
                    <option value="5" disabled={diseableCambioEstado.disabledFacturada}>Facturada</option>
                    <option value="3" disabled={diseableCambioEstado.disabledCancelar}>Cancelada</option> */}
                    <option value="6" disabled={true}>Pendiente</option>
                    <option value="1" disabled={true}>Reservado</option>
                    <option value="2" disabled={true}>Confirmado</option>
                    <option value="11" disabled={true}>Ingreso a sala</option>
                    <option value="12" disabled={true}>Preparación</option>
                    <option value="13" disabled={true}>Cirugía</option>
                    <option value="4" disabled={true}>Realizada</option>
                    <option value="15" disabled={true}>Recuperación</option>                    
                    <option value="14" disabled={true}>Salida</option>                    
                    <option value="5" disabled={true}>Facturada</option>
                    <option value="3" disabled={true}>Cancelada</option>
                    <option value="8" disabled={true}>Reprogramar</option>
                </select>
              </div>
            </div>
          </td>
          <td className="text-xs text-gray-900 font-medium px-1 py-2 whitespace-pre-wrap">
          <button
              onClick={handleOnClickNovedadesAdministrativas}
              //disabled={false}
              type="button"
              className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 5C7 5 2.73 8.82 1.5 12.5c1.23 3.68 5.5 7.5 10.5 7.5s9.27-3.82 10.5-7.5C21.27 8.82 17 5 12 5z"></path>
  <circle cx="12" cy="12.5" r="3" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></circle>
</svg>

            </button>
          </td>
          {/* <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            <div className="">
              {props.user.ProEsta != '3'?
              <button
              onClick={modificar}
              
              type="button"
              className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
            >
              Modificar
            </button>:
            null  
            }
                    
            </div>
          </td> */}
          {/* <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            {props.user.ProEsta != '3'?
            <button
            onClick={handleOnclickPaquetesQx}
            type="button"
            className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          >
            Paquetes
          </button>:
          null
          }
                    
            
          </td> */}
          {/* <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
          <button
                      onClick={handleClickConsentimientoInformado}
                      type="button"
                      className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                    >
                      Consentimiento
                    </button>
          </td> */}
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.ProCirCod? props.user.ProCirCod:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.MPTDoc? props.user.MPTDoc:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.MPCedu? props.user.MPCedu:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">
          <div className='flex '>
            {props.user.MPNOMC? props.user.MPNOMC:null }

            {
              props.user.PrcMulDsc? (props.user.PrcMulDsc.trim() === "PROGRAMADA"? 
              <div className="ml-2 h-6 w-6 rounded-full bg-blue-300 flex justify-center items-center text-blue-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">P</text>
  </svg>
</div>
:
(props.user.PrcMulDsc.trim() === "URGENCIAS"? 
<div className="ml-2 h-6 w-6 rounded-full bg-red-300 flex justify-center items-center text-red-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">U</text>
  </svg>
</div> 
:
(props.user.PrcMulDsc.trim() === "AMBULATORIA"? 
<div className="ml-2 h-6 w-6 rounded-full bg-blue-400 flex justify-center items-center text-blue-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">A</text>
  </svg>
</div> 
:
null
)
)

              ) :null
            }
            
            
 
</div>

          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.ProFec? props.user.ProFec.split(' ')[0]:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.CrgDes? props.user.CrgDes:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.ProHorI != "  :  :  "? props.user.ProHorI:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.ProHorF? props.user.ProHorF:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.MPTele?props.user.MPTele:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.ConsDet? props.user.ConsDet:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.MPFchN? calcularEdad(props.user.MPFchN.split(' ')[0]):null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left ">
            {props.user.MENOMB? props.user.MENOMB:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left ">
            {props.user.camaUsuario? props.user.camaUsuario:null}
          </td>
        </tr>     
        </tbody>
      {modalOn && < ModalCirugia setModalOn={setModalOn} setChoice={setChoice} user={props.user} passDataActualizaTablaPacientes={props.passDataActualizaTablaPacientes}/>} 
      {/* {modalOnPaquetesQx? <ModalAgregarPaquetesQuirurgicosP setmodalOnPaquetesQx={setmodalOnPaquetesQx} user={props.user}/>:null} */}
      {modalOnAgregarPaquetesQuirurgicos? <ModalAgregarPaquetesQuirurgicos setmodalOnAgregarPaquetesQuirurgicos={setmodalOnAgregarPaquetesQuirurgicos} idCirugia={props.user.ProCirCod} user={props.user} passActualizarTablaProcedimiento={passActualizarTablaProcedimiento}/>:null}
      {modalOnConfirmar? <ModalConfirmarElActoQuirurgico setmodalOnConfirmar={setmodalOnConfirmar} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnConsentimientoInformado? <ModalConsentimientoInformado setmodalOnConsentimientoInformado={setmodalOnConsentimientoInformado} user={props.user}/>:null}
      {modalOnCambioEstadoReservado? <CambioDeEstadoReservado setmodalOnCambioEstadoReservado={setmodalOnCambioEstadoReservado} user={props.user} passActualizarTablaProcedimiento={passActualizarTablaProcedimiento}  passChildCambioDeEstado={passChildCambioDeEstado}/>:null}  
      {modalOnCambioEstadoIngresoSala? <CambioDeEstadoIngresoASala setmodalOnCambioEstadoIngresoSala={setmodalOnCambioEstadoIngresoSala} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnCambioEstadoPreparado? <CambioDeEstadoPreparado setmodalOnCambioEstadoPreparado={setmodalOnCambioEstadoPreparado} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnCambioEstadoCirugia? <CambioDeEstadoCirugia setmodalOnCambioEstadoCirugia={setmodalOnCambioEstadoCirugia} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnCambioEstadoRecuperacion? <CambioDeEstadoRecuperacion setmodalOnCambioEstadoRecuperacion={setmodalOnCambioEstadoRecuperacion} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnCambioEstadoSalida? <CambioDeEstadoSalida setmodalOnCambioEstadoSalida={setmodalOnCambioEstadoSalida} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnCambioEstadoRealizada? <CambioDeEstadoRealizada setmodalOnCambioEstadoRealizada={setmodalOnCambioEstadoRealizada} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnValidarDiagnostico? <ModalValidarDiagnosticoAntesDeConfirmarCirugia setmodalOnValidarDiagnostico={setmodalOnValidarDiagnostico}/>:null}
      {validarQuirofano? <ModalValidarQuirofano setvalidarQuirofano={setvalidarQuirofano}/>:null}
      {modalOnCambioEstadoCancelado? <CambioDeEstadoCancelar setmodalOnCambioEstadoCancelado={setmodalOnCambioEstadoCancelado} user={props.user} passDataActualizaTablaPacientes={props.passDataActualizaTablaPacientes}/>:null}
      {modalOnModificarButton? <ModalValidarButtonModificarProgramacionCirugia setmodalOnModificarButton={setmodalOnModificarButton}/>:null}
      {novedadesAdministra? <NovedadesAdministrativas setnovedadesAdministra={setnovedadesAdministra} user={props.user}/>:null}

      </>
  )
}

export default TablaProgramacionCirugia